import { atom } from "recoil";

export interface FeedbackModalState {
    visible: boolean;
    rating: number;
    comment: string;
    tags: string[];
    userId: string;
    processId: string;
    targetId: string;
    triggerCount?: number;
    // Add optional callbacks
    onSubmit?: (feedbackData: { rating: number; comment: string; tags: string[] }) => void;
    onCancel?: () => void;
}

export const feedbackModalState = atom<FeedbackModalState>({
    key: "feedbackModalState",
    default: {
        visible: false,
        rating: 0,
        comment: "",
        tags: [],
        userId: "",
        processId: "",
        targetId: "",
        triggerCount: 0,
        // Callbacks are undefined by default
        onSubmit: undefined,
        onCancel: undefined,
    },
});